// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1lJyT","actions":"GroupTable_actions__2MJuJ","deleteModalFooter":"GroupTable_deleteModalFooter__3DfF8"};